export const applyTheme = (settings = {}) => {
  const root = document.documentElement;

  if (settings.website_primary_color) {
    root.style.setProperty("--website-primary-color", settings.website_primary_color);
  }
  if (settings.website_secondary_color) {
    root.style.setProperty("--website-secondary-color", settings.website_secondary_color);
  }

  if (settings.invoice_primary_color) {
    root.style.setProperty("--invoice-primary-color", settings.invoice_primary_color);
  }
  if (settings.invoice_secondary_color) {
    root.style.setProperty("--invoice-secondary-color", settings.invoice_secondary_color);
  }

  if (settings.company_logo) {
    const logoElement = document.getElementById("app-logo");
    if (logoElement) logoElement.src = settings.company_logo;
  }
};
